import api from '@/lib/api';

export interface AgentCapability {
  key: string;
  label: string;
  description: string;
  enabled: boolean;
  parent?: string;
}

class AgentCapabilitiesService {
  async list(): Promise<AgentCapability[]> {
    const res = await api.get('/agent-cases/capabilities');
    return res.data?.data || [];
  }

  async set(capability: string, enabled: boolean): Promise<void> {
    await api.put('/agent-cases/capabilities', { capability, enabled });
  }
}

export default new AgentCapabilitiesService();
